var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25384 0.978432C9.39736 1.86998 9.04146 2.74817 8.56603 3.37246C8.05681 4.04172 7.17258 4.56537 6.3125 4.54832C6.1459 3.69525 6.53897 2.81125 7.02058 2.21285C7.55146 1.55314 8.4667 1.04138 9.25384 0.978432ZM11.8485 13.6113C12.2856 12.9302 12.4467 12.5873 12.7833 11.8181C10.2651 10.899 9.82118 7.36019 12.2874 5.97121C11.5186 5.03589 10.4493 4.50188 9.44596 4.51342C8.72163 4.52175 8.22767 4.71513 7.77875 4.89088C7.40484 5.03726 7.06217 5.17142 6.64365 5.17623C6.19144 5.18143 5.78916 5.04323 5.36781 4.89847C4.90452 4.73931 4.41817 4.57222 3.81705 4.57914C2.6893 4.59211 1.49791 5.29029 0.751053 6.46988C-0.299456 8.12873 -0.0825634 11.2248 1.68203 13.8444C2.3131 14.7818 3.15324 15.8339 4.237 15.8312C4.68578 15.8304 4.983 15.6938 5.30476 15.546C5.67327 15.3768 6.07398 15.1927 6.77145 15.1808C7.47324 15.1687 7.87154 15.3456 8.2391 15.5087C8.5558 15.6493 8.84966 15.7798 9.29516 15.7706C10.3787 15.7483 11.2396 14.5625 11.8485 13.6113Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.582bb816481609e6ba561ce21b984b12.svg";
export { ForwardRef as ReactComponent };